<template>
  <v-data-table
    :headers="headers"
    :items="driedAbaloneSummaries"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="DriedAbaloneSummary-button-new"
          @click="$router.push({
            name: 'dried-abalone-summary-EditDriedAbaloneSummary'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'dried-abalone-summary-EditDriedAbaloneSummary',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListDriedAbaloneSummary',
  module: 'DriedAbaloneSummary',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('driedAbaloneSummaries', ['driedAbaloneSummaries']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('date'),
          value: 'date',
        },
        {
          text: this.$$t('receivingDate'),
          value: 'receivingDate',
        },
        {
          text: this.$$t('farm'),
          value: 'farm',
        },
        {
          text: this.$$t('cookingDate'),
          value: 'cookingDate',
        },
        {
          text: this.$$t('drySizeRange'),
          value: 'drySizeRange',
        },
        {
          text: this.$$t('liveWeight'),
          value: 'liveWeight',
        },
        {
          text: this.$$t('outOfSalt'),
          value: 'outOfSalt',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_driedAbaloneSummaries();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('driedAbaloneSummaries', ['LOAD_driedAbaloneSummaries', 'DELETE_driedAbaloneSummary']),
    /** Delete DriedAbaloneSummary from the collection
     */
    async remove(DriedAbaloneSummary) {
      this.isLoading = true;
      await this.DELETE_DriedAbaloneSummary(DriedAbaloneSummary);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# DriedAbaloneSummary example

'''js
<DriedAbaloneSummary />
'''
</docs>
